import { actions as routerActions } from 'redux-router5';

import {
  getCurrentRouteName,
  getCurrentRouteParams,
  navigateTo,
} from '@neptune/shared/routing-business-logic';

import { NThunkAction } from 'state/types';

export function updateNavigationCompare(
  compare: string | undefined,
): NThunkAction<void, ReturnType<typeof routerActions.navigateTo>> {
  return (dispatch, getState) => {
    const routeName = getCurrentRouteName(getState());
    const currentRouteParams = getCurrentRouteParams(getState());

    dispatch(navigateTo(routeName, { ...currentRouteParams, compare }, { replace: true }));
  };
}
